import { AmbientLight, HemisphereLight, OrthographicCamera, PointLight, Scene, WebGLRenderer } from "three";

export class AccelerationScene {

    constructor(public canvas: HTMLCanvasElement) {
        
        const scene = new Scene();
        scene.add(new HemisphereLight(0xffffff, 0xaaaaaa, 2));
        scene.add(new AmbientLight(0xffffff));

        const renderer = new WebGLRenderer({
            powerPreference: 'high-performance',
            precision: 'lowp',
            antialias: true,
            canvas: canvas,
            logarithmicDepthBuffer: false
        });
        renderer.setClearColor(0xaaaaaa, 0);
        renderer.autoClear = false;

        const camera = new OrthographicCamera(10, 10, 10, 10, 0.1, 1000);
        const cameraPointLight = new PointLight(0xffffff, 100000);
        cameraPointLight.position.set(0, 0, 0);
        camera.add(cameraPointLight);
        scene.add(camera);

    }

}